import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { DropdownCard, Status } from 'shared/ui'
import type { Contact } from 'entities/Contacts/model/Contact'
import { useSurveySendStore } from 'widgets/SurveySend/lib/useSurveySendStore'
import styles from './styles.module.scss'

type ISurveySendDropdownItemProps = {
  contact: Contact
  onClick: () => void
}

export const SurveySendDropdownItem: FC<ISurveySendDropdownItemProps> = observer(
  ({ contact, onClick }) => {
    const store = useSurveySendStore()
    const blockReason = store.getBlockReason(contact)

    return (
      <DropdownCard
        item={{
          id: 'send_survey',
          label: store.label,
          iconL: 'clipboardCheck',
          disabled: !!blockReason,
          tooltipProps: {
            placement: 'left-start',
            label: blockReason,
            className: styles.tooltip,
          },
          labelContent: (
            <div className={styles.dropdownLabel}>
              {store.label}
              <Status
                title={'New'}
                intent={'purple'}
                emphasis={'high'}
                size={'label'}
                disabled={!!blockReason}
              />
            </div>
          ),
        }}
        onChange={() => {
          onClick()
          store.enrollContacts([contact.id])
        }}
      />
    )
  }
)
